export default "__VITE_ASSET__BK$7jgW___"